export enum IdleWarningStates {
    PrimaryTimerStarted,
    PrimaryTimerExpired,
    SecondaryTimerStarted,
    SecondaryTimerExpired,
    SecondaryTimerCancelled,
}
